module.exports = __webpack_public_path__ + "img/book_docker.3158b4aa.jpg";